import WizardModal from './WizardModal'

export default WizardModal
